<template>
  <div class="flex flex-col" v-if="props.products?.length">
    <h2 class="mx-auto px-5 desktop:px-[3rem] desktopLarge:px-[5.625rem]">{{ props.title }}</h2>

    <Splide
      class="pb-[70px] pt-8 laptop:pb-0"
      :has-track="false"
      :options="options"
      aria-label="$t('our-newest-products')"
    >
      <SplideTrack>
        <SplideSlide
          class="-mx-2 -mb-2 px-2 pb-2 pt-[35px] laptop:max-w-[400px]"
          v-for="product in props.products"
          :key="JSON.stringify(product)"
        >
          <ProductCard :product="product" />
        </SplideSlide>
      </SplideTrack>

      <div class="splide__arrows">
        <button class="splide__arrow--prev -px-[100px] absolute top-[40%]">
          <svg width="94" height="25" viewBox="0 0 94 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 24H90.5L61 1" stroke="black" stroke-width="2" />
          </svg>
        </button>
        <button class="splide__arrow--next -px-[100px] absolute top-[40%]">
          <svg width="94" height="25" viewBox="0 0 94 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 24H90.5L61 1" stroke="black" stroke-width="2" />
          </svg>
        </button>
      </div>
    </Splide>
    <NextBtn
      class="mx-auto px-5 pt-[23px] laptop:pt-12 desktop:px-[3rem] desktopLarge:px-[5.625rem]"
      :to="`${props.link}`"
      :text="props.buttonText || ''"
    />
  </div>
</template>
<script lang="ts" setup>
import { ProductCardFragment } from "#gql";
import { Splide, SplideSlide, SplideTrack } from "@splidejs/vue-splide";
import "@splidejs/vue-splide/css";

const props = defineProps<{
  products?: ProductCardFragment[] | undefined | null;
  title: string | undefined | null;
  buttonText: string | undefined | null;
  link?: string | undefined | null;
}>();

watch(
  () => props.products,
  (product) => {
    if (product) {
      options.perPage = Math.min(4, product.length || 0);
    }
  }
);

let options = {
  type: "slider",
  perPage: Math.min(4, props.products?.length || 0),
  gap: "2rem",
  pagination: false,
  arrows: true,
  breakpoints: {
    1024: { arrows: false, perPage: 3, pagination: true },
    758: { perPage: 2 },
    640: { perPage: 1, pagination: true, padding: "0", gap: 0 },
  },
};
</script>
<style lang="scss" scoped>
:deep(.splide__pagination__page.is-active) {
  background: black;
  transform: none;
  z-index: 1;
}
:deep(.splide__arrow--prev) {
  left: -6em;
  transition: opacity 0.2s ease-out;

  &:disabled {
    opacity: 0;
  }
}

:deep(.splide__arrow--next) {
  right: -6em;
  transition: opacity 0.2s ease-out;

  &:disabled {
    opacity: 0;
  }
}
</style>
